// We don't have yet such enum on backend, but instead the effective type of the layer is detected
// based on layerStructureType value and on layer settings. Ideally would be to introduce such enum
// in backend and use it instead of other layer types, checks and flags in the future.
// For now a type was introduced for frontend with an ability to get it based on layer settings (see getWorkbookLayerType()).

import { assertType } from 'cadenza/utils/custom-error';

/**
 * Effective workbook map layer type, detected based on layer settings and used to decide how to render it.
 * Used mostly in the workbook specific code, for example to display the layer in the designer or build a map context from the wb redux store.
 * In contrast to LayerType it focuses on the type used to create it in workbook and not how it is then rendered in the OL map.
 */
export type WorkbookLayerType =
  | 'STANDARD_GROUP'
  | 'TOGGLE_GROUP'
  | 'DATA_VIEW'
  | 'SKETCH'
  | 'EXTERNAL_WMS'
  | 'EXTERNAL_WMTS'
  | 'EXTERNAL_VECTOR_TILE'
  | 'EXTERNAL_ARCGIS_MAP'
  | 'EXTERNAL_ARCGIS_IMAGE'
  | 'CLASSIC';

const GROUP_WORKBOOK_LAYER_TYPES = ['STANDARD_GROUP', 'TOGGLE_GROUP'] as const;

type GroupWorkbookLayerType = (typeof GROUP_WORKBOOK_LAYER_TYPES)[number];

type SingleWorkbookLayerType = Exclude<WorkbookLayerType, GroupWorkbookLayerType>;

export function assertSingleWorkbookLayerType(
  workbookLayerType: WorkbookLayerType,
): asserts workbookLayerType is SingleWorkbookLayerType {
  assertType<SingleWorkbookLayerType>(
    workbookLayerType,
    !GROUP_WORKBOOK_LAYER_TYPES.includes(workbookLayerType as never),
  );
}
